export default __webpack_public_path__ + "static/media/welcome.c2f83c8d.png";